import {
  FaWarehouse,
  FaUsers,
  FaCog,
  FaTruck,
  FaClipboard,
  FaGasPump,
  FaCalendar,
  FaPencilRuler,
  FaBell,
} from "react-icons/fa"
import { IconType } from "react-icons"
import { FaHouseChimney } from "react-icons/fa6"

export interface SectionConfig {
  name: string
  icon: IconType
  order: number
}

export const SECTION_CONFIG: Record<string, SectionConfig> = {
  planner: { name: "Planner", icon: FaCalendar, order: 4 },
  designer: { name: "Designer", icon: FaPencilRuler, order: 0 },
  projects: { name: "Projects", icon: FaTruck, order: 2 },
  orders: { name: "Orders", icon: FaClipboard, order: 3 },
  assets: { name: "Assets", icon: FaWarehouse, order: 5 },
  customers: { name: "Customers", icon: FaUsers, order: 6 },
  systems: { name: "Systems", icon: FaCog, order: 7 },
  filling: { name: "Production", icon: FaGasPump, order: 8 },
  alerts: { name: "Alerts", icon: FaBell, order: 9 },
  dashboards: { name: "Home", icon: FaHouseChimney, order: -1 },
}
